import { AspectRatio, Box } from '@amzn/ring-ui-react-components';
import { LegacyRef } from 'react';
import ReactPlayer, { ReactPlayerProps } from 'react-player';
import { ASPECT_RATIO } from './constants';

export interface VideoPlayerProps extends ReactPlayerProps {
  orientation: string;
  optimizedVideo?: boolean;
  showPlayerControls?: boolean;
  url: string;
  'data-testid'?: string;
  // videoState: VideoStateProps;
  caption?: string;
  innerRef?: LegacyRef<ReactPlayer>;
}

export const VideoPlayer = ({
  innerRef,
  'data-testid': dataTestId,
  showPlayerControls,
  orientation,
  caption,
  poster,
  ...props
}: VideoPlayerProps) => {
  const ratio =
    orientation === 'portrait' ? ASPECT_RATIO.PORTRAIT : ASPECT_RATIO.LANDSCAPE;

  const gradientStyle = {
    background:
      'linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 99.03%)',
  };

  return (
    <AspectRatio height="100%" ratio={ratio} position="relative">
      <Box>
        <ReactPlayer
          ref={innerRef}
          data-testid={dataTestId}
          width="100%"
          height="100%"
          controls={showPlayerControls || false}
          volume={1}
          progressInterval={100}
          playsinline
          position="relative"
          //workaround https://github.com/CookPete/react-player/issues/62
          config={{
            file: { attributes: { poster, crossOrigin: 'anonymous' } },
          }}
          {...props}
        />
        {caption && (
          <Box
            textStyle="body-small-medium"
            color="white"
            position="absolute"
            bottom={0}
            left={0}
            right={0}
            p={2}
            data-testid="caption"
            zIndex={3}
            style={gradientStyle}
          >
            {caption}
          </Box>
        )}
      </Box>
    </AspectRatio>
  );
};
